import { Typography } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import React from 'react';
import Alert from 'styleguide/layout/Alert';

export type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /** Pauses the recording. Omit when the recording cannot be paused. */
  onPause?: () => void;
};

const StopConfirmationDialog: React.FC<Props> = ({
  open,
  onConfirm,
  onCancel,
  onPause,
}) => {
  if (!open) {
    return null;
  }

  return (
    <Alert
      open
      onSubmit={onConfirm}
      onCancel={onCancel}
      icon="stop"
      title="Stop Recording?"
      cancelButtonText="Continue Recording"
      submitButtonText="Confirm Stop"
      secondaryAction={
        onPause && (
          <Button
            disableElevation
            variant="outlined"
            color="primary"
            onClick={onPause}
          >
            Pause Recording
          </Button>
        )
      }
    >
      <Typography>
        Stopping this recording will finalize the audio for this encounter. You
        will not be able to resume recording or upload another audio file for
        this encounter after it is stopped.
      </Typography>
      <Typography>Are you sure you want to stop recording?</Typography>
    </Alert>
  );
};

export default React.memo(StopConfirmationDialog);
